var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.helpArticle)?_c('a',{staticClass:"d-flex flex-row align-items-center",class:[
    'signal-help-article-link',
    { dark: _vm.dark },
    { 'i-link learn-more': _vm.learnMore },
  ],attrs:{"href":_vm.helpLinkUrl,"target":"_blank"}},[(_vm.learnMore)?_c('span',[_vm._v("Learn more")]):_vm._t("default",function(){return [_c('font-awesome-icon',{attrs:{"icon":"question-circle"}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }